import { apiClient } from './client'
import endpoints from './endpoints'
import { unwrapSingleWithMeta, type SingleWithMeta } from './normalize'

export interface AttestationAreas {
  establishmentHa: number
  programHa: number
  ineligibleHa: number
  excludedHa: number
  offProgramHa: number
}

export type AttestationWarningCode = 'CI_OVERLAP_CI' | 'CI_OVERLAP_EA' | 'CI_OVERLAP_INELIGIBILITY'

export interface AttestationWarning {
  code: AttestationWarningCode
  overlapHa: number
  details: {
    carbonInstance: { id: string; name: string }
    overlapWith: { id?: string; name: string; layer?: string }
  }
}

export interface AttestationAreasMeta {
  warnings: AttestationWarning[]
}

export default async function getAttestationAreas({
  farmId,
  signal,
}: {
  farmId: string
  signal?: AbortSignal
}): Promise<SingleWithMeta<AttestationAreas, AttestationAreasMeta>> {
  const response = await apiClient.get(endpoints.v2.farms.attestationAreas(farmId), { signal })
  return unwrapSingleWithMeta<AttestationAreas, AttestationAreasMeta>(response)
}
